<template>
  <section class="not_found text_center">
    <p>ページが見つかりません。</p>
    <p v-if="!isLp"><router-link :to="{ name: 'Top' }" class="decoration_link_arrow_blue">トップページへ戻る</router-link></p>
  </section>
</template>

<script>
export default {
  name: 'notFound',
  computed: {
    isLp () {
      return this.$route.name === 'Lp' || this.$route.name === 'PageLpPreview'
    }
  }
}
</script>
